import type { RoomCalendarEventDto } from '@hub-wifi/shared'

/**
 * Top-line identity label for a building-calendar chip.
 *
 * Hub-source events (booked via Hub UI/API) carry the resolved coworker name
 * and company on the DTO — those are the user-facing labels we want. The
 * underlying Graph event's organizer is always the shared service mailbox
 * (`bookings@tesset.com`), which is meaningless to end users and intentionally
 * NOT exposed on the DTO.
 *
 * Outlook-source events (meetings placed directly in the room mailbox by
 * someone outside Hub) have no RoomBooking row, so we render the generic
 * `externalLabel` ("External" / "Externo") — we don't expose Outlook
 * organizers either, since we can't reliably map them to a Hub identity.
 */
export function formatChipIdentity(event: RoomCalendarEventDto, externalLabel: string): string {
  if (event.source === 'hub') {
    const name = event.coworkerName ?? ''
    const company = event.coworkerCompany ?? externalLabel
    return name ? `${name} - ${company}` : company
  }
  return externalLabel
}
